export default __webpack_public_path__ + "static/media/neon.04e6d0d8.png";